import { useEffect, useState } from 'react'

import { authHeader } from '../../api/'
import { refreshToken } from '../auth/'

const { REACT_APP_API_URL } = import.meta.env

export const useMaintenanceText = () => {
  const [data, setData] = useState(null)

  useEffect(() => {
    ;(async () => {
      try {
        await refreshToken()
        const url = `${REACT_APP_API_URL}/system/maintenance/message`
        const options = { method: 'GET', headers: { ...authHeader() } }
        const response = await fetch(url, options)
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        const payload = await response.json()
        const message = payload?.data?.maintenance_message
        setData(message ?? null)
      } catch {
        setData(null)
      }
    })()
  }, [])

  return data
}
